import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import MyTypography from "@saleor/components/MyTypography";
import classNames from "classnames";
import React from "react";
import { useIntl } from "react-intl";

import useStyles from "../styles";
import { ErrorsName } from "./ChangePasswordPage";

interface IValidateMessage {
  errors?: Record<ErrorsName, boolean>;
}
const ValidateMessage: React.FC<IValidateMessage> = ({ errors }) => {
  const classes = useStyles();
  const intl = useIntl();
  return (
    <div>
      <div className={classes.infoResetPassWord}>
        {!errors || errors.minCharacters === false ? (
          <CheckIcon
            data-testid="CheckIcon"
            style={{
              color: !errors
                ? "#cccccc"
                : errors.minCharacters === false
                ? "#28A745"
                : ""
            }}
          />
        ) : (
          <CloseIcon
            data-testid="CloseIcon"
            style={{
              color: "#FF2600"
            }}
          />
        )}
        <MyTypography
          variant="body3"
          data-testid="validate-message"
          className={classNames({
            [classes.textError]: errors?.minCharacters
          })}
        >
          {intl.formatMessage({ defaultMessage: "At least 8 characters" })}
        </MyTypography>
      </div>
      <div className={classes.infoResetPassWord}>
        {!errors || errors.uppercase === false ? (
          <CheckIcon
            data-testid="CheckIcon"
            style={{
              color: !errors
                ? "#cccccc"
                : errors.uppercase === false
                ? "#28A745"
                : ""
            }}
          />
        ) : (
          <CloseIcon
            data-testid="CloseIcon"
            style={{
              color: "#FF2600"
            }}
          />
        )}
        <MyTypography
          variant="body3"
          data-testid="validate-message"
          className={classNames({
            [classes.textError]: errors?.uppercase
          })}
        >
          {intl.formatMessage({ defaultMessage: "An uppercase character" })}
        </MyTypography>
      </div>
      <div className={classes.infoResetPassWord}>
        {!errors || errors.lowercase === false ? (
          <CheckIcon
            data-testid="CheckIcon"
            style={{
              color: !errors
                ? "#cccccc"
                : errors.lowercase === false
                ? "#28A745"
                : ""
            }}
          />
        ) : (
          <CloseIcon
            data-testid="CloseIcon"
            style={{
              color: "#FF2600"
            }}
          />
        )}
        <MyTypography
          variant="body3"
          data-testid="validate-message"
          className={classNames({
            [classes.textError]: errors?.lowercase
          })}
        >
          {intl.formatMessage({ defaultMessage: "A lowercase character" })}
        </MyTypography>
      </div>
      <div className={classes.infoResetPassWord}>
        {!errors || errors.number === false ? (
          <CheckIcon
            data-testid="CheckIcon"
            style={{
              color: !errors
                ? "#cccccc"
                : errors.number === false
                ? "#28A745"
                : ""
            }}
          />
        ) : (
          <CloseIcon
            data-testid="CloseIcon"
            style={{
              color: "#FF2600"
            }}
          />
        )}
        <MyTypography
          variant="body3"
          data-testid="validate-message"
          className={classNames({
            [classes.textError]: errors?.number
          })}
        >
          {intl.formatMessage({ defaultMessage: "A number" })}
        </MyTypography>
      </div>
    </div>
  );
};

export default ValidateMessage;
